module.exports = __webpack_public_path__ + "static/media/redo-alt-light.5218b42a.svg";